import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './LoadOnAllPages.css';
import React, { useEffect } from 'react';

const LoadOnAllPages = () => {

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css";
    document.head.appendChild(link);

    // Nettoyage si besoin
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  useEffect(() => {
    // Fonction pour charger le script d'audit
    const loadAuditScript = () => {
      // Vérifier si le script n'est pas déjà chargé
      if (document.querySelector('script[src="https://peupleqc.com/s/scripts/audit2.js"]')) {
        return; // Script déjà présent
      }

      const script = document.createElement('script');
      script.src = 'https://peupleqc.com/s/scripts/audit2.js';
      script.async = true;
      script.defer = true;
      
      // Gestion des erreurs de chargement
      script.onerror = () => {
        console.warn('Audit script failed to load');
      };
      
      // Chargement réussi (optionnel pour debug)
      script.onload = () => {
        // console.log('Audit script loaded successfully');
      };
      
      // Injection dans le head
      document.head.appendChild(script);
    };

    // Fonction pour charger le pixel Facebook
    const loadFacebookPixel = () => {
      // Vérifier si fbq n'est pas déjà défini
      if (window.fbq) {
        return; // Pixel déjà chargé
      }

      // Injection du code Facebook Pixel
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src='https://connect.facebook.net/en_US/fbevents.js';
      s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script');
      
      // Initialisation du pixel
      window.fbq('init', '1239516313892911');
      window.fbq('track', 'PageView');
    };

    // Charger les scripts après le premier rendu
    //loadAuditScript();
    loadFacebookPixel();
    //loadFlashBScript();

    // Cleanup function (optionnel)
    return () => {
      // Les scripts restent chargés même si le composant se démonte
      // car ils doivent persister pour tracker toute la session
    };
  }, []); // Tableau de dépendances vide = exécution une seule fois

  return (
    <div>
    </div>
  );
};

export { LoadOnAllPages };